exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#app[data-v-73ffdd65]{min-height:100%}router-link[data-v-73ffdd65]{color:#323232}.router-link-active[data-v-73ffdd65]{color:#fff;background:#e21919}.active_tab ul li a[data-v-73ffdd65]{display:block;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-73ffdd65","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 46
// module chunks = 0